import { HttpClient } from '@angular/common/http';
import { SearchUser } from '../../interfaces/users/search-user';
import { PaginatedRepository } from '../pagination/paginated.repository';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';

@Injectable({
  providedIn: 'root',
})
export class SearchUsersService extends PaginatedRepository<SearchUser> {
  protected override _baseLink: string;

  constructor(
    http: HttpClient,
    messageService: ToastrService,
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig) {
    super(
      http,
      messageService);

    this._baseLink = `${config.rootUrl}/Users`;
  }
}
